export default class Project {
  constructor(public name: string, public href: string, public description: string) {}
}
